import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f4412406"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notification-manage" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { key: 3 }
const _hoisted_6 = ["textContent"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "stop-tips" }, "是否确认终止该证书通知？", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ResponsiveRow = _resolveComponent("ResponsiveRow")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_CirclePlus = _resolveComponent("CirclePlus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Remove = _resolveComponent("Remove")!
  const _component_app_page = _resolveComponent("app-page")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_page, { dialog: _ctx.dialog }, {
      fheader: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_form, {
            size: "default",
            ref: "queryForm",
            "label-width": "86px",
            model: _ctx.params,
            onKeyup: _cache[6] || (_cache[6] = _withKeys(($event: any) => (_ctx.handleSearch()), ["enter"]))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ResponsiveRow, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "通知时间",
                    prop: "dateRange"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.params.dateRange,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.params.dateRange) = $event)),
                        type: "daterange",
                        format: "YYYY-MM-DD",
                        "range-separator": "至",
                        "start-placeholder": "开始时间",
                        "end-placeholder": "结束时间"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "创建人" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        placeholder: "请输入创建人",
                        modelValue: _ctx.params.creatorName,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.params.creatorName) = $event)),
                        modelModifiers: { trim: true },
                        maxlength: "200",
                        clearable: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    "label-width": "0",
                    class: "margin-left-20"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        size: "default",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleSearch())),
                        onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.handleSearch()), ["enter"]))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 查询 ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        size: "default",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleReset()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 重置 ")
                        ]),
                        _: 1
                      }),
                      (_ctx.$has(_ctx.permissionConfig.CREATE))
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            size: "default",
                            type: "primary",
                            class: "margin-bottom-10",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleAddOrEdit('add')))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 创建证书配置 ")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      main: _withCtx(({
          height
        }) => [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          height: height,
          key: height,
          data: _ctx.tableData,
          border: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "noticeTime",
              label: "通知时间",
              align: "center",
              width: "200"
            }, {
              default: _withCtx(({ row: { noticeTime } }) => [
                _createTextVNode(_toDisplayString(_ctx.$filters.formatTime(noticeTime)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "通知信息",
              align: "center"
            }, {
              default: _withCtx(({ row: { noticeType, emails } }) => [
                (noticeType.includes('飞书群'))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, "飞书群"))
                  : _createCommentVNode("", true),
                (noticeType.includes('邮箱') && noticeType.includes('飞书群'))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, "，"))
                  : _createCommentVNode("", true),
                (noticeType.includes('邮箱'))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, "邮箱"))
                  : _createCommentVNode("", true),
                (emails !== '')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, "(" + _toDisplayString(emails) + ")", 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "remark",
              label: "备注",
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                  content: _withCtx(() => [
                    _createTextVNode(_toDisplayString(row.remark), 1)
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "remark",
                      textContent: _toDisplayString(row.remark)
                    }, null, 8, _hoisted_6)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "创建信息",
              align: "center"
            }, {
              default: _withCtx(({ row: { creatorName, createdTime } }) => [
                _createTextVNode(_toDisplayString(creatorName) + " ", 1),
                _createElementVNode("div", null, _toDisplayString(_ctx.$filters.formatTime(createdTime)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "noticeTime",
              label: "操作",
              align: "center",
              width: "200"
            }, {
              default: _withCtx(({ row }) => [
                (row.isEnabled === '1' && _ctx.$has(_ctx.permissionConfig.UPDATE))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "text",
                      onClick: ($event: any) => (_ctx.handleAddOrEdit('edit', row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("编辑")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                (row.isEnabled === '1' && _ctx.$has(_ctx.permissionConfig.ENABLE))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      type: "text",
                      style: {"color":"red"},
                      onClick: ($event: any) => (_ctx.handleStop(row.id))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("终止")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.$has(_ctx.permissionConfig.LOG))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 2,
                      type: "text",
                      onClick: ($event: any) => (_ctx.handleOperate(row.id))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("操作记录")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 2
        }, 1032, ["height", "data"])), [
          [_directive_loading, _ctx.tableLoading]
        ])
      ]),
      ffooter: _withCtx(() => [
        _createVNode(_component_el_row, {
          style: {"width":"100%","padding-top":"10px"},
          type: "flex",
          justify: "end"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_pagination, {
              total: _ctx.tableTotal,
              "current-page": _ctx.params.pageNum,
              size: _ctx.params.pageSize,
              onSizeChange: _ctx.handleSizeChange,
              onCurrentChange: _ctx.handleCurrentChange
            }, null, 8, ["total", "current-page", "size", "onSizeChange", "onCurrentChange"])
          ]),
          _: 1
        })
      ]),
      certificate: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "certificateForm",
          "label-width": "100px",
          inline: false,
          size: "default",
          rules: _ctx.formRules,
          model: _ctx.formData
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "通知时间",
              prop: "noticeTime"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 20 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          style: {"width":"100%"},
                          modelValue: _ctx.formData.noticeTime,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.noticeTime) = $event)),
                          type: "date",
                          placeholder: "请选择通知时间"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "通知类型",
              prop: "noticeType"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox_group, {
                  modelValue: _ctx.formData.noticeType,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.noticeType) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_checkbox, { label: "飞书群" }),
                    _createVNode(_component_el_checkbox, { label: "邮箱" })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (_ctx.isShowEmails)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.formData.emails, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_form_item, {
                    label: `${index === 0 ? '邮箱' : ''}`,
                    key: index,
                    prop: 'emails.' + index + '.email',
                    rules: _ctx.formRules.email
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 20 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                class: "margin-bottom-10",
                                size: "default",
                                modelValue: item.email,
                                "onUpdate:modelValue": ($event: any) => ((item.email) = $event),
                                placeholder: "请输入接收通知的邮箱信息"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_col, { span: 4 }, {
                            default: _withCtx(() => [
                              (index === 0)
                                ? (_openBlock(), _createBlock(_component_el_icon, {
                                    key: 0,
                                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleEmails('add'))),
                                    style: {"color":"#409eff"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_CirclePlus)
                                    ]),
                                    _: 1
                                  }))
                                : (_openBlock(), _createBlock(_component_el_icon, {
                                    key: 1,
                                    onClick: ($event: any) => (_ctx.handleEmails('remove', index)),
                                    style: {"color":"red"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Remove)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["label", "prop", "rules"]))
                }), 128))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              label: "备注",
              prop: "remark"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  maxlength: "200",
                  type: "textarea",
                  autosize: { minRows: 3, maxRows: 4},
                  placeholder: "请输入备注信息，限200字符",
                  modelValue: _ctx.formData.remark,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.remark) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["rules", "model"])
      ]),
      stop: _withCtx(() => [
        _hoisted_7,
        _createVNode(_component_el_form, {
          ref: "stopForm",
          "label-width": "100px",
          inline: false,
          size: "default",
          model: _ctx.stopFormData
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "备注",
              prop: "remark"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  maxlength: "100",
                  type: "textarea",
                  autosize: { minRows: 3, maxRows: 4},
                  placeholder: "请输入备注信息，限100字符",
                  modelValue: _ctx.stopFormData.remark,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.stopFormData.remark) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      operate: _withCtx(() => [
        _createVNode(_component_el_table, {
          border: "",
          data: _ctx.operationData
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              align: "center",
              label: "操作时间",
              width: "200"
            }, {
              default: _withCtx(({ row: { createdTime } }) => [
                _createTextVNode(_toDisplayString(_ctx.$filters.formatTime(createdTime)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              align: "center",
              label: "操作概述",
              prop: "message"
            }, {
              default: _withCtx(({ row: { type, description } }) => [
                type
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(type) + "证书 ", 1)
                    ], 64))
                  : _createCommentVNode("", true),
                description
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" (备注: " + _toDisplayString(description) + ") ", 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              align: "center",
              label: "操作人",
              prop: "creatorName"
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["dialog"])
  ]))
}